import { LipSyncController, Viseme } from './LipSyncController';
export class SpeechController extends EventTarget {
    active = false;
    silent = false;
    text = '';
    language = 'ru-RU';
    started = 0;
    private timer = 0;
    private generation = 0;
    private resolve?: () => void;
    private audio?: HTMLAudioElement;
    lip = new LipSyncController();
    get amplitude() { return this.active ? this.lip.approximate((performance.now() - this.started) / 1000) : 0; }
    private begin(silent: boolean) { this.active = true; this.silent = silent; this.started = performance.now(); this.dispatchEvent(new CustomEvent('start', { detail: { silent, text: this.text } })); }
    private finish() { this.active = false; clearTimeout(this.timer); this.resolve?.(); this.resolve = undefined; this.dispatchEvent(new Event('end')); }
    async speak(text: string) {
        this.stop();
        this.text = text;
        const token = ++this.generation;
        return new Promise<void>(resolve => {
            this.resolve = resolve;
            const silent = () => { if (token !== this.generation)
                return; this.begin(true); this.timer = window.setTimeout(() => this.finish(), Math.max(1500, text.length / 15 * 1000)); };
            if (!('speechSynthesis' in window)) {
                silent();
                return;
            }
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = this.language;
            utterance.rate = .93;
            const voice = speechSynthesis.getVoices().find(v => v.lang.startsWith(this.language.split('-')[0]));
            if (voice)
                utterance.voice = voice;
            let started = false;
            utterance.onstart = () => { if (token !== this.generation)
                return; started = true; clearTimeout(this.timer); this.begin(false); };
            utterance.onend = () => { if (token === this.generation)
                this.finish(); };
            utterance.onerror = () => { if (token === this.generation)
                silent(); };
            speechSynthesis.speak(utterance);
            this.timer = window.setTimeout(() => { if (!started && token === this.generation) {
                speechSynthesis.cancel();
                silent();
            } }, 2500);
        });
    }
    async speakAudio(url: string, visemes: Viseme[] = []) { this.stop(); this.lip.timeline = visemes; this.audio = new Audio(url); this.audio.crossOrigin = 'anonymous'; this.audio.onended = () => this.finish(); this.audio.onerror = () => { this.finish(); this.dispatchEvent(new Event('error')); }; await this.audio.play(); this.begin(false); return new Promise<void>(r => this.resolve = r); }
    get preciseWeights() { return this.audio && this.active ? this.lip.at(this.audio.currentTime) : {}; }
    stop() { this.generation++; clearTimeout(this.timer); if ('speechSynthesis' in window)
        speechSynthesis.cancel(); this.audio?.pause(); this.audio = undefined; this.lip.timeline = []; this.finish(); }
    destroy() { this.stop(); }
}
